import type { QueryClient } from '@tanstack/react-query';

const shouldInvalidateQuery = (queryKey: unknown): boolean => {
    if (typeof queryKey !== 'string') {
        return false;
    }

    return (
        queryKey === 'getIncomeConfigs' ||
        queryKey === 'getIncomeSplitOverview' ||
        queryKey === 'getActiveMoneyMap' ||
        queryKey === 'getActiveMoneyMapWithIncomeSplit' ||
        queryKey.startsWith('getMoneyMapsForMembership') ||
        queryKey.startsWith('getMoneyMap/') ||
        queryKey.startsWith('getMoneyMapCompleteness') ||
        queryKey === 'getMembershipMoneyMapAccounts' ||
        queryKey.startsWith('useGetProposedIncomeSplit/') ||
        queryKey.startsWith('useGetProposedLegacyIncomeSplit/')
    );
};

export const invalidateIncomeSplitAndMoneyMapQueries = async (
    queryClient: QueryClient,
) => {
    await queryClient.invalidateQueries({
        predicate: (query) => shouldInvalidateQuery(query.queryKey[0]),
    });
};

/**
 * Review-numbers save marks the previous map inactive and inserts a new active
 * one. Refetch every cached money-map query, including maps fetched by id and
 * proposed income splits for those ids, and cancel any request still in flight
 * from before the save.
 */
export const refreshMoneyMapsAfterReviewUpdate = async (
    queryClient: QueryClient,
) => {
    await queryClient.invalidateQueries({
        predicate: (query) => shouldInvalidateQuery(query.queryKey[0]),
        refetchType: 'all',
    });
};
